var React = require('react');

function MusicInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"#000","strokeWidth":"2"},[React.createElement("ellipse",{"cx":"17","cy":"48","rx":"7","ry":"6","key":0}),React.createElement("path",{"d":"M24 47V17l26-5v30M24 25l26-5-26 5z","key":1}),React.createElement("ellipse",{"cx":"43","cy":"43","rx":"7","ry":"6","key":2})]));
}

MusicInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = MusicInline;

MusicInline.default = MusicInline;
